(() => {
  angular.module('app').component('hostInpatientGuaranteeLettersCommonAdmissionDetailsComponent', {
    templateUrl: require('./admissionDetails.component.html'),
    controller: AdmissionDetailsController,
    controllerAs: 'vm',
    bindings: {
      guaranteeLetterNumber: '<',
      isPrintButtonHidden: '<',
      currencyCode: '<',
      isRejected: '<',
    }
  });

  AdmissionDetailsController.$inject = [
    '$stateParams',
    'abp.services.app.inpatientGuaranteeLetter',
    'abp.services.app.hostServiceRequest',
  ];

  function AdmissionDetailsController(
    $stateParams,
    inpatientGuaranteeLetterSvc,
    hostServiceRequestSvc,
  ) {
    const vm = this;
    vm.loading = 0;
    vm.admission = null;
    vm.diagnosis = null;
    vm.documents = []
    vm.admissionTypes = [];
    vm.viewMore = false;
    vm.printing = null;
    vm.finalBillAmount = null;
    vm.interimBillAmount = null;

    vm.$onChanges = onChanges;
    vm.getAdmissionType = getAdmissionType;
    vm.getDateTimeString = getDateTimeString;

    function onChanges(changes) {
      if (changes.guaranteeLetterNumber && changes.guaranteeLetterNumber.currentValue) {
        getAdmissionDetails();
        getGLPrintingDetails();
        getfinalBillAmount();
        getInterimBillAmount();
      }
    }

    function getGLPrintingDetails() {
      vm.loading += 1;
      inpatientGuaranteeLetterSvc.getServiceRequestDetailsForTimelineButtons({
        id: vm.guaranteeLetterNumber
      }).success((data) => {
        vm.printing = {
          printGlEnabled: data.printGlEnabled,
          printGlUrl: data.printGlUrl,
          printNonGlPatientUrl: data.printNonGlPatientUrl,
        }
      }).finally(() => {
        vm.loading -= 1;
      });
    }

    function getfinalBillAmount() {
      vm.loading += 1;
      hostServiceRequestSvc.getFinalBillAmountForAdmissionDetails({
        id: vm.guaranteeLetterNumber
      }).success((data) => {
        vm.finalBillAmount = data.finalBillAmount;
      }).finally(() => {
        vm.loading -= 1;
      });
    }

    function getInterimBillAmount() {
      vm.loading += 1;
      hostServiceRequestSvc.getInterimBillForAdmissionDetails({
        id: vm.guaranteeLetterNumber
      }).success((data) => {
        vm.interimBillAmount = data.interimBillAmount;
      }).finally(() => {
        vm.loading -= 1;
      })
    }
    function getAdmissionDetails() {
      vm.loading += 1;
      inpatientGuaranteeLetterSvc.getProcessAdmissionDetails({
        id: vm.guaranteeLetterNumber
      }).success((data) => {
        vm.admission = {
          hospitalName: data.hospitalName,
          hospitalContactNumber: data.hospitalContactNumber,
          guaranteeLetterNumber: data.guaranteeLetterNumber,
          admissionNumber: data.admissionNumber,
          scheduledAdmissionTime: data.scheduledAdmissionTime,
          checkedInTime: data.checkedInTime,
          admissionType: data.admissionType,
          doctors: _.map(data.guaranteeLetterDoctors, 'name').join(', '),
          estimatedCost: data.estimatedCost,
          estimatedDischargeDate: data.estimatedDischargeDate,
          latestRequestType: data.latestRequestType
        };

        vm.documents = _.map(data.supportingDocuments, (d) => ({
            externalObjectId: d.externalObjectId,
            url: d.url,
            name: d.name,
            state: d.state,
            uploader: `${d.uploader  } ${  getDateTimeString(d.uploadedTime)}`,
            applied: d.isApplied
          }));

        vm.diagnosis = {
          selected: _.map(data.provisionalDiagnosis, (p) => ({
              code: p.code,
              description: p.description,
              displayDate: p.displayDiagnosisDate,
              date: p.diagnosisDate
            })),
          icd: _.map(data.provisionalDiagnosis, (d) => ({
              code: d.code,
              description: `(${  d.code  }) ${  d.description}`
            }))
        };

        vm.admissionTypes = data.admissionTypes;
      }).finally(() => {
        vm.loading -= 1;
      });
    }

    function getAdmissionType() {
      if (vm.admission && vm.admission.admissionType) {
        const admissionType = _.find(vm.admissionTypes, (t) => t.id === vm.admission.admissionType);

        return admissionType.name;
      }
      return null;
    }

    function getDateTimeString(date, timeZoneId = $stateParams.timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }
  }
})();
